import { useGanttSegmentsContext } from '../context/GanttSegmentsContext.js';

export const useGanttSegmentPosition = (
  start: number,
  end: number,
): { start: number; end: number; width: number; isNegative: boolean } => {
  const { segmentScale } = useGanttSegmentsContext();

  const [startPx = 0, endPx = 0] = [segmentScale?.(start), segmentScale?.(end)];
  return {
    start: startPx,
    end: endPx,
    width: Math.abs(endPx - startPx),
    isNegative: endPx - startPx < 0,
  };
};
